import Vue from "vue";
import moment from "moment";

Vue.filter("capitalize", function (sentence) {
  if (!sentence) return "";
  sentence = sentence.toString();
  return sentence
    .toLowerCase()
    .split(" ")
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
});

Vue.filter("globalDate", function (date) {
  if (date) {
    return moment(String(date)).format("YYYY/MM/DD");
  }
});

Vue.filter('currency', number => {
  function formatPrice(value) {
    const val = (value / 1).toFixed(2).replace(',', '.')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  const n = parseFloat(number);
  if (!isNaN(n) && n !== 0) {
    return formatPrice(n);
  } else {
    return '-'
  }
});

Vue.filter('currencyZero', number => {
  function formatPrice(value) {
    const val = (value / 1).toFixed(2).replace(',', '.')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  const n = parseFloat(number);
  if (!isNaN(n) && n !== 0) {
    return formatPrice(n);
  } else {
    return '0.00'
  }
});

Vue.filter('fcapitalize', function (value) {
  if (!value) return '';
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
});

// 2023-08-03 21:58:26 to dd/mm/yyyy hh:mm:ss
Vue.filter('prettyDate', function (value) {
  if (!value) return '';

  const date = new Date(value);
  const day = ('0' + date.getDate()).slice(-2);
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const year = date.getFullYear();
  const hours = ('0' + date.getHours()).slice(-2);
  const minutes = ('0' + date.getMinutes()).slice(-2);
  const seconds = ('0' + date.getSeconds()).slice(-2);

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
});



Vue.filter('prettyDateWithoutTime', function (value) {
  if (!value) return value;
  const date = new Date(value);
  
  // Convert to UTC to avoid time zone discrepancies
  const utcDate = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
  
  const day = String(utcDate.getUTCDate()).padStart(2, '0');
  const month = String(utcDate.getUTCMonth() + 1).padStart(2, '0');
  const year = utcDate.getUTCFullYear();
  
  return `${day}/${month}/${year}`;
});
